var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-wallet-transaction-progress"},[_c('div',{staticClass:"c-wallet-transaction-progress__bar"},[_c('span',{staticClass:"c-wallet-transaction-progress__bar--percent",style:({ width: _vm.value + '%' })})]),_c('small',[_vm._v(_vm._s(_vm.value)+"%")])])
}
var staticRenderFns = []

export { render, staticRenderFns }